// Shapes the scheduling API returns to the screens. Shared so the API and the web compile against
// one contract. No rules here — see permissions.ts and workflow.ts for those.
export const WFH_PORTIONS = ['FULL', 'HALF'];
//# sourceMappingURL=views.js.map